import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export const FramerPage = ({ path }) => (
  <div className={styles.container}>
    <iframe
      src={`${process.env.REACT_APP_FRAMER_WEBSITE_URL}${path}`}
      title="Framer Embedded Page"
      className={styles.iframe}
    />
  </div>
);

FramerPage.propTypes = {
  path: PropTypes.string,
};
